import React from "react";
import { Breadcrumb, Button, Col, FloatButton, Form, Input, Row, Select, Spin, message } from "antd";
import { Link, Navigate } from "react-router-dom";

import { POST_API, POST_CATCH, getToken, titleWeb } from "../../services/hello-api";
import { IoArrowBack } from "react-icons/io5";
import ReactInputMask from "react-input-mask";

import { IoLogoWhatsapp } from 'react-icons/io5';

class ContatoForm extends React.Component {

    state = {
        _navigate: false,
        _loading: false,
        _screen: true,
        _params: window.location.href.split('/'),
        _type: this.props.type === 'add' ? 'Adicionar' : 'Editar',
        defaultValue: null,
        doc: false,
        fileList: [],
        filters: { INSTITUTION_ID: [], COURSE_ID: [], CLASS_ID: [] }
    }

    back = this.props.url;

    componentDidMount = () => {
        titleWeb('Contatos')
        this.onFilters()
        if (this.props.type === 'add') {
            this.setState({_screen: false})
        } else if (this.props.type === 'edit') {
            this.onView()
        }
    }

    onFilters = () => {
        POST_API('/contact/filters.php', { token: getToken() }).then(rs => rs.json()).then(res => {
            if (res.return) {
                this.setState({filters: res.data})
            } else {
                message.error({ content: res.msg, key: 'screen' })
            }
        }).catch(() => POST_CATCH())
    }

    onChangeFilter = (v) => {
        POST_API('/contact/filters.php', { token: getToken(), INSTITUTION_ID: v }).then(rs => rs.json()).then(res => {
            if (res.return) {
                this.setState({filters: { ...this.state.filters, COURSE_ID: res.data.COURSE_ID, CLASS_ID: res.data.CLASS_ID }})
            } else {
                message.error({ content: res.msg, key: 'screen' })
            }
        }).catch(() => POST_CATCH())
    }

    onChangeFilterCourse = (v) => {
        POST_API('/contact/filters.php', { token: getToken(), COURSE_ID: v }).then(rs => rs.json()).then(res => {
            if (res.return) {
                this.setState({filters: { ...this.state.filters, CLASS_ID: res.data.CLASS_ID }})
            } else {
                message.error({ content: res.msg, key: 'screen' })
            }
        }).catch(() => POST_CATCH())
    }

    onView = async () => {
        var filter = {ID: isNaN(this.state._params[6]) ? this.state._params[7] : this.state._params[6]}
        POST_API('/contact/search.php', { token: getToken(), type: 'view', filter: JSON.stringify(filter) }).then(rs => rs.json()).then(res => {
            if (res.return) {
                this.setState({defaultValue: res.data})
            } else {
                message.warning({ content: res.msg, key: 'screen' })
            }
        }).catch(() => POST_CATCH()).finally(() => this.setState({_screen: false}))
    }

    onSend = (values) => {
        this.setState({_loading: true})
        POST_API('/contact/save.php', { token: getToken(), type: this.props.type, master: JSON.stringify(values) }).then(rs => rs.json()).then(res => {
            if (res.return) {
                message.success({ content: res.msg, key: 'screen' })
                this.setState({_navigate: true})
            } else {
                message.warning({ content: res.msg, key: 'screen' })
            }
        }).catch(() => POST_CATCH()).finally(() => this.setState({_loading: false}))
    }

    render = () => {

        const routes = this.props.bread;

        if (this.state._navigate) {
            return (<Navigate to={this.back} />)
        }

        return (
            <Row>
                <Col xs={24} md={0}>
                    <Breadcrumb items={routes} className="bread-page" />
                    <Link to={this.back}><FloatButton className="float-button back" icon={<IoArrowBack color="#FFF" size={25} />}/></Link>
                </Col>
                <Col xs={0} md={24} className="page-header">
                    <Row className="table__row_table" gutter={[8,8]}>
                        <Col span={18}>
                            <Breadcrumb items={routes} />
                        </Col>
                        <Col span={6} style={{display: 'flex', justifyContent: 'flex-end'}}>
                            <Link to={this.back}><Button onClick={this.onChangePage} type="primary" size="small" shape="round" className="sys-btn-primary sys-btn-small">Voltar</Button></Link>
                        </Col>
                    </Row>
                </Col>
                <Col span={24} className="page-content">
                    <Row className="table__row_table" gutter={[8,8]} align={'bottom'}>
                        { this.state._screen ? <Col span={24}><center><Spin /></center></Col> : (
                            <Col span={24}>
                                <Form layout="vertical" className={`admin-form`} onFinish={this.onSend} initialValues={this.state.defaultValue}>
                                    <Form.Item hidden name="ID">
                                        <Input />
                                    </Form.Item>
                                    <Form.Item hidden name="CREDENTIAL_ID">
                                        <Input />
                                    </Form.Item>
                                    <Row gutter={[16,0]}>
                                        <Col md={12} xs={24}>
                                            <Form.Item label="Instituição" name="INSTITUTION_ID" class="profile-form-item" rules={[{required: true, message: 'Campo obrigatório*'}]}>
                                                <Select onChange={this.onChangeFilter}>
                                                    { this.state.filters.INSTITUTION_ID.map( (v, i) => <Select.Option key={i} value={v.ID}>{v.NAME}</Select.Option> ) }
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col md={8} xs={12}>
                                            <Form.Item label="Curso" name="COURSE_ID" class="profile-form-item" rules={[{required: true, message: 'Campo obrigatório*'}]}>
                                                <Select>
                                                    { this.state.filters.COURSE_ID.map( (v, i) => <Select.Option key={i} value={v.ID}>{v.NAME}</Select.Option> ) }
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col md={4} xs={12}>
                                            <Form.Item label="Turma" name="CLASS_ID" class="profile-form-item" rules={[{required: true, message: 'Campo obrigatório*'}]}>
                                                <Select>
                                                    { this.state.filters.CLASS_ID.map( (v, i) => <Select.Option key={i} value={v.ID}>{v.SEMESTER_NAME} / {v.YEAR}</Select.Option> ) }
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col md={13} xs={24}>
                                            <Form.Item label="Nome Completo" name="NAME" class="profile-form-item" rules={[{required: true, message: 'Campo obrigatório*'}]}>
                                                <Input />
                                            </Form.Item>
                                        </Col>
                                        <Col md={6} xs={24}>
                                            <Form.Item label="E-mail" name="EMAIL" class="profile-form-item" rules={[{required: true, message: 'Campo obrigatório*'}, {type: 'email', message: 'E-mail inválido'}]}>
                                                <Input />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={12} md={5}>
                                            <Form.Item label="Whatsapp" name="PHONE"  rules={[{required: true, message: 'Campo obrigatório*'}]}>
                                                <span class="ant-input-group-wrapper css-dev-only-do-not-override-nnuwmp">
                                                    <span class="ant-input-wrapper ant-input-group css-dev-only-do-not-override-nnuwmp">
                                                        <span class="ant-input-group-addon"><IoLogoWhatsapp /></span>
                                                        <ReactInputMask className="ant-input css-dev-only-do-not-override-nnuwmp css-nnuwmp" mask={'+55 (99) 99999-9999'} value={this.state.defaultValue?.PHONE} />
                                                    </span>
                                                </span>
                                            </Form.Item>
                                        </Col>
                                        
                                        <Col span={24}>
                                            <Button loading={this.state._loading} htmlType="submit" type="primary" shape="round" style={{float: 'right'}}>Salvar</Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </Col>
                        )}
                    </Row>
                </Col>
            </Row>
        )

    }

}

export default ContatoForm;